import axios from "axios";

export const c4uHttp = axios.create({
  baseURL: process.env.REACT_APP_API_C4U_URL,
});
